export async function getClientPing() {
  const start = performance.now();
  try {
    await fetch("https://www.google.com", { mode: "no-cors" });
    const end = performance.now();
    return Math.round(end - start);
  } catch (err) {
    return null;
  }
}

export function estimateSignalStrength(ping) {
  if (!ping) return { strength: "No connection", color: "red" };
  if (ping < 100) return { strength: "Excellent", color: "darkgreen" };
  if (ping < 300) return { strength: "Good", color: "lightgreen" };
  if (ping < 600) return { strength: "Weak", color: "orange" };
  return { strength: "Poor", color: "red" };
}
